import { Image, ImageProps } from 'theme-ui'

const Concentrator = (props: ImageProps) => {
  return <Image width={16} src="/imgs/concentrator.png" {...props} />
}
export default Concentrator
